<template>
    <div
        :style="{
            'background-color': backgroundColor,
        }"
        class="flex mx-auto justify-center w-full max-w-lg p-4 border rounded-[5px] text-white"
    >
        <div class="w-6 shrink-0 flex items-center justify-center self-center">
            <slot name="icon" />
        </div>

        <div class="ml-3 text-sm">
            <slot name="default" />
        </div>
    </div>
</template>

<script lang="ts" setup>
defineProps({
    backgroundColor: {
        type: String,
        required: true,
    },
});
</script>
